module.exports = __webpack_public_path__ + "static/media/mplayer_10.fa325ca6.ico";